// Content protection: blocks text selection, copy/cut, right-click and image dragging
// everywhere except form fields (search, quantity, checkout notes, login…). Disabled in the theme editor.
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const isField = (target) =>
    target instanceof Element && target.closest('input, textarea, select, [contenteditable="true"]');

  // Right-click is blocked everywhere, form fields included.
  document.addEventListener('contextmenu', (event) => event.preventDefault(), { capture: true });

  ['copy', 'cut', 'selectstart', 'dragstart'].forEach((type) => {
    document.addEventListener(type, (event) => {
      if (!isField(event.target)) event.preventDefault();
    }, { capture: true });
  });

  // Ctrl/Cmd + C, X, S, U, P (copy, cut, save, view source, print) outside form fields.
  document.addEventListener('keydown', (event) => {
    if (!(event.ctrlKey || event.metaKey) || isField(event.target)) return;
    if (['c', 'x', 's', 'u', 'p'].includes(event.key.toLowerCase())) event.preventDefault();
  }, { capture: true });

  // Developer tools shortcuts: F12, Ctrl/Cmd+Shift+I / J / C, Cmd+Option+I / J / C / U.
  document.addEventListener('keydown', (event) => {
    const key = (event.key || '').toLowerCase();
    const mod = event.ctrlKey || event.metaKey;
    if (event.key === 'F12' || (mod && (event.shiftKey || event.altKey) && ['i', 'j', 'c', 'u'].includes(key))) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, { capture: true });
})();

// iOS Safari only applies :active styles when the page has a touch listener.
document.addEventListener('touchstart', () => {}, { passive: true });

// Footer: the social-icon row spans exactly the width of the copyright line.
(() => {
  const sync = () => {
    const rights = document.querySelector('[data-xo-rights]');
    if (!rights) return;
    const width = rights.getBoundingClientRect().width;
    document.querySelectorAll('[data-xo-social-row]').forEach((row) => {
      row.style.setProperty('--xo-rights-w', `${Math.round(width)}px`);
    });
  };
  const start = () => {
    sync();
    const rights = document.querySelector('[data-xo-rights]');
    if (rights && 'ResizeObserver' in window) new ResizeObserver(sync).observe(rights);
    document.fonts?.ready.then(sync);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
